import { FeatureConfiguration } from "..";
import { OrderAgainReducer } from "./reducers";

export * from "./reducers";

export default function (config: FeatureConfiguration) {
    config.reducers.orderAgain = OrderAgainReducer;
}
